import { combineReducers } from "redux";
import Auth from "./Auth";

export default combineReducers({
  Auth,
});
